(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsDetailController', EpmParamsDetailController);

    EpmParamsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EpmParams'];

    function EpmParamsDetailController($scope, $rootScope, $stateParams, previousState, entity, EpmParams) {
        var vm = this;

        vm.epmParams = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:epmParamsUpdate', function(event, result) {
            vm.epmParams = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
